import {COcomm} from '@3cad/nextcore';
import {NextApiClient} from '@3cad/nextcore';
import {bus} from "@store/dau";

export default {
    data() {
        return {
            guestAdmitted: true,
            userLoggedRsa: false
        };
    },
    watch: {
        user: {
            handler: function (newVal, oldVal) {
                if (newVal && !newVal.guest) {
                    this.guestAdmitted = true;
                }
            },
            deep: true
        },
    },
    created() {
        window.addEventListener('msgFromParent', this.messageFromParent);
        bus.$on("userloggedrsa", () => {
            // this.translations = App.translator.getTranslations();
            if (this.iframeCom) {
                this.iframeCom.sendMsg({
                    status: 0,
                    action: "APP",
                    msg: "User authenticated through RSA"
                });
            }
        });
        bus.$on("loginrsafailed", data => {
            // this.translations = App.translator.getTranslations();
            if (this.iframeCom) {
                this.iframeCom.sendMsg(data);
            }
        });
    },
    mounted() {
        if (this.iframeCom) {
            this.iframeCom.sendMsg({
                status: 0,
                action: "APP",
                msg: "APP loaded"
            });
            this.$store.commit("setIntoIframe", true);
            let uid = NextApiClient.getUID();
            this.guestAdmitted = !!uid;
        }
    },
    destroyed() {
        window.removeEventListener('msgFromParent', this.messageFromParent);
    },
    methods: {
        messageFromParent(e) {
            if (!e.data.action) {
                console.warn("Missing action");
            }
            let data = null;
            if (e.data.data !== undefined) {
                data = e.data.data;
            } else {
                data = e.data;
            }
            let action = e.data.action;
            this.requestFromParent(action, data);
        },
        requestFromParent(action, data) {
            console.log("Request from parent", action);
        },
        responseToParent(data, isObj = false) {
            if (data) {
                let status = parseInt(data.status);
                let action = data.action;
                let content = data.content || data.msg;
                if (isObj) {
                    content = JSON.stringify(data.content);
                }
                if (this.iframeCom) {
                    let msg = {
                        status: status,
                        action: action,
                        msg: content
                    };
                    console.log("messageToParent", msg);
                    this.iframeCom.sendMsg(msg);
                }
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/configurator/embedded.js